import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { store } from "./store/store";
import { Provider } from "react-redux";
import { AuthProvider as SupabaseAuthProvider } from "./supabase/AuthProvider";
import { ToastProvider } from "./context/CustomToast";
import { ScoreTrackingProvider } from "./context/ScoreTrackingContext";
import { captureMarketingParams } from "./utils/marketingParams";

// Capture marketing attribution params from WordPress on app load
captureMarketingParams();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <SupabaseAuthProvider>
      <ToastProvider>
        <ScoreTrackingProvider>
          <App />
        </ScoreTrackingProvider>
      </ToastProvider>
    </SupabaseAuthProvider>
  </Provider>
);
